import { Subject, takeUntil } from 'rxjs';
import { ChangeDetectorRef, Component } from '@angular/core';

import { LandingPagesWithoutTranslationType, LandingPageTypeEnum } from '@sifca-monorepo/ecommerce-generator';

import { LandingPagesService, SharedService, SlidesService } from '../../../services';

@Component({
  template: '',
})
export class MobileBasePageComponent {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  landingPage: LandingPagesWithoutTranslationType;
  landingPages: LandingPagesWithoutTranslationType[];

  constructor(
    protected sharedService: SharedService,
    protected slidesService: SlidesService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected landingPagesService: LandingPagesService,
    protected landingPageType: LandingPageTypeEnum,
  ) {
    this.landingPagesService.landingPages$.pipe(takeUntil(this.unsubscribeAll)).subscribe((res) => {
      this.landingPage = res?.objects?.[0];
      this.landingPages = res?.objects;
      this.changeDetectorRef.markForCheck();
    });
    this.landingPagesService.findLandingPagesByTargetAndTypePaginated([landingPageType]).subscribe();
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
